export default {
    path: '/video',
    meta: {
        requiresAuth: true
    },
    components: {
        default: () => import(/* webpackChunkName: "Video" */ '../pages/Video.vue')
    }
}